import wpAjax from "../helpers/axios";

const initPeBrochureForm = () => {
  const forms = document.querySelectorAll(".js-pe-brochure-form");

  if (forms.length >= 1) {
    forms.forEach((form) => {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();

        const res = await submitPeBrochureForm(form);
        const messageEl = form.querySelector(".c-form__message");

        // show a success or error message
        if (res.success) {
          if (messageEl.hasAttribute("data-success-message")) {
            messageEl.innerHTML = messageEl.getAttribute(
              "data-success-message",
            );
          } else {
            messageEl.innerHTML =
              "Thanks for submitting. Please keep an eye on your inbox for your brochure.";
          }
        } else {
          messageEl.innerHTML =
            "Sorry there was an error submitting the form. Please check your network and try again later.";
        }

        form.classList.remove("submitting");
        messageEl.style.display = "block";

        console.log("res", res);
      });
    });
  }
};

const submitPeBrochureForm = async (form) => {
  form.classList.add("submitting");
  const messageEl = form.querySelector(".c-form__message");

  // Reset error messages
  messageEl.innerHTML = "";
  messageEl.style.display = "none";

  // Get data for ajax
  const formData = new FormData(form);
  formData.append("action", "ajax_submit_pe_brochure_form");
  console.log(formData);

  // Debug form values
  for (const pair of formData.entries()) {
    console.log(`${pair[0]} = ${pair[1]}`);
  }

  try {
    const { data } = await wpAjax.post("", formData);

    return data;
  } catch (err) {
    console.error(err);
    return { success: false };
  }
};

export { submitPeBrochureForm, initPeBrochureForm };
